import http_request from './http_request'
import config from 'config'

function getDrawIt(id) {
	return http_request.get(config.api + 'draw_it/' + id).send()
}

function saveDrawIt(
	id,
	instructions,
	iconId,
	iconBackgroundId,
	presentationId = 0,
	isFlippedHorizontally = false,
	isFlippedVertically = false,
	scale = '1',
	rotatedDegrees = 0,
	isModified = false,
	final = false,
	offsetX = 0,
	offsetY = 0,
) {
	return http_request.put(config.api + 'draw_it/' + id).send({
		instructions,
		iconId,
		iconBackgroundId,
		presentationId,
		isFlippedHorizontally,
		isFlippedVertically,
		scale,
		rotatedDegrees,
		isModified,
		final,
		offsetX,
		offsetY,
	})
}

export default {
	getDrawIt,
	saveDrawIt,
}
